import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=497bf148&scoped=true&v-slot%3Acontent=true&"
import script from "./Regist.vue?vue&type=script&lang=ts&"
export * from "./Regist.vue?vue&type=script&lang=ts&"
import style0 from "./Regist.vue?vue&type=style&index=0&id=497bf148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bf148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VOverlay,VProgressCircular,VRow})
